import { ContentResultListComponent } from "./contentResultList.container";
import { ProductResultListComponent } from "./productResultList.container";

type Props = {
    className?: string;
};

const ProductResultList = (props: Props) => (
    <ProductResultListComponent {...props} />
);

const ContentResultList = (props: Props) => (
    <ContentResultListComponent {...props} />
);

export { ContentResultList, ProductResultList };
